import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Col, Modal, Row, Container, Dropdown, Alert, Form, Badge } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalList from '../../components/Modals/ModalList';
import ModalEntityViewer from '../../components/Modals/ModalEntityViewer';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import moment from 'moment';
import { WriteXml } from 'fattura-elettronica';
import { settings } from '../settings';
import { Editor } from '@tinymce/tinymce-react';
import FieldPreview from '../../components/Entity/FieldPreview';



export default function DGLTH_customer_order({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()
    const [statusPaymentOrderModal, setStatusPaymentOrderModal] = useState(false)
    const userInfo = LoginManager.getUserInfo();

    // Modal for registering new payment
    const [paymentCompilerStatus, setPaymentCompilerStatus] = useState(false)
    const [paymentCompilerData, setPaymentCompilerData] = useState(null)

    // Modal for creating replacement order
    const [replacementCompilerStatus, setReplacementCompilerStatus] = useState(false)
    const [replacementCompilerData, setReplacementCompilerData] = useState(null)





    const [statusModalEntityViewerCustomerOrder, setStatusModalEntityViewerCustomerOrder] = useState(false)
    function closeModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(false)
    }
    function openModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(true)
    }

    function previewCustomerOrder(item) {
        navigate('/page/CustomerOrderPreview?id=' + item.id)
    }

    function viewInvoices(item) {
        const params = {
            'query': '',
            'fields': [],
            'constraints': [{ fieldName: 'idCustomerOrder', type: 'value', value: item.id.toString() }]
        }
        const q = btoa(JSON.stringify(params))
        navigate(`/entity/invoice?q=${q}`)
    }


    function newCustomerOrderPayment(item) {
        setPaymentCompilerData({
            idCustomerOrder: item
        })
        setPaymentCompilerStatus(true)
    }

    function closePaymentCompiler() {
        setPaymentCompilerStatus(false)
        setPaymentCompilerData(null)
    }

    async function openReplacementCompiler(item) {
        try {
            const res = await DataManager.getItem('customer_order', item.id)
            if (res.success !== 1 || !res.body || res.body.length === 0) {
                Swal.fire({ title: 'Errore', text: 'Impossibile recuperare i dati dell\'ordine.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }
            const orderData = res.body[0]

            const replacementData = {
                idCustomer: orderData.idCustomer,
                idCustomerOffer: orderData.idCustomerOffer,
                riferimento: orderData.riferimento,
                deliveryDate: orderData.deliveryDate,
                realDeliveryDate: orderData.realDeliveryDate,
                finishDeliveryDate: orderData.finishDeliveryDate,
                deliveryNotes: orderData.deliveryNotes,
                idUserDelivery: orderData.idUserDelivery,
                floor: orderData.floor,
                elevator: orderData.elevator,
                parking: orderData.parking,
                ladder_truck: orderData.ladder_truck,
                hoist_elevator: orderData.hoist_elevator,
                parquet: orderData.parquet,
                pedestrian_zone: orderData.pedestrian_zone,
                no_traffic_zone: orderData.no_traffic_zone,
                building: orderData.building,
                zone: orderData.zone,
                vat: orderData.vat,
                idPaymentCondition: orderData.idPaymentCondition,
                notes: orderData.notes,
                discount: orderData.discount,
                increase: orderData.increase,
                transportCost: orderData.transportCost,
                transportAndAssembly: orderData.transportAndAssembly,
                methodPayment: orderData.methodPayment,
                bank: orderData.bank,
                iban: orderData.iban,
                deliveryAddress: orderData.deliveryAddress,
                latitude: orderData.latitude,
                longitude: orderData.longitude,
                locality: orderData.locality,
                type: { value: '10_REPLACEMENT', label: '10_REPLACEMENT' },
                status: { value: '0_PENDING', label: '0_PENDING' },
                rows: []
            }

            setReplacementCompilerData(replacementData)
            setReplacementCompilerStatus(true)
        } catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Errore durante il caricamento dei dati.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    function closeReplacementCompiler() {
        setReplacementCompilerStatus(false)
        setReplacementCompilerData(null)
    }

    async function createInvoice(item) {
        try {
            // Controlla se esiste già una fattura per questo ordine
            const existingInvoices = await DataManager.searchItems(
                'invoice', 1, 1,
                { field: 'id', order: 'DESC' },
                '', [],
                [{ fieldName: 'idCustomerOrder', type: 'value', value: item.id }]
            )
            if (existingInvoices.success === 1 && existingInvoices.body && existingInvoices.body.length > 0) {
                Swal.fire({
                    title: 'Attenzione',
                    text: 'Esiste già una fattura per questo ordine. Non è possibile creare più di una fattura per ordine.',
                    icon: 'warning',
                    confirmButtonColor: '#ffc107'
                })
                return
            }

            // Carica i dati dell'ordine per ottenere i totali e le righe
            const orderRes = await DataManager.getItem('customer_order', item.id)
            if (orderRes.success !== 1 || !orderRes.body || orderRes.body.length === 0) {
                Swal.fire({ title: 'Errore', text: 'Impossibile recuperare i dati dell\'ordine.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }
            const orderData = orderRes.body[0]

            // Validazione campi obbligatori per generazione XML FatturaPA
            const missingFields = []
            const customer = orderData.idCustomer

            // Controllo dati cliente
            if (!customer) {
                missingFields.push('Cliente non associato all\'ordine')
            } else {
                const isPrivato = parseInt(customer.category?.value) === 0
                if (!customer.name) missingFields.push('Denominazione cliente')
                if (isPrivato) {
                    // Privato: CodiceFiscale obbligatorio, SDI/PEC non richiesti
                    if (!customer.taxCode) missingFields.push('Codice Fiscale cliente (obbligatorio per privati)')
                } else {
                    // Società: P.IVA obbligatoria, SDI o PEC richiesti
                    if (!customer.vatNumber) missingFields.push('P.IVA cliente')
                    if (!customer.sdi && !customer.pec) missingFields.push('Codice SDI o PEC cliente')
                }
                if (!customer.address) missingFields.push('Indirizzo cliente')
                if (!customer.cap && !customer.postalCode) missingFields.push('CAP cliente')
                if (!customer.city && !customer.locality) missingFields.push('Comune cliente')
                if (!customer.province) missingFields.push('Provincia cliente')
            }

            // Controllo righe ordine
            if (!orderData.rows || orderData.rows.length === 0) {
                missingFields.push('Righe ordine (almeno una riga richiesta)')
            }

            // Controllo dati azienda in settings
            if (!settings.dati_fattura) {
                missingFields.push('Configurazione dati fattura in settings')
            } else {
                if (!settings.dati_fattura.PIVA) missingFields.push('P.IVA azienda (settings)')
                if (!settings.dati_fattura.denominazione) missingFields.push('Denominazione azienda (settings)')
                if (!settings.dati_fattura.indirizzo) missingFields.push('Indirizzo azienda (settings)')
                if (!settings.dati_fattura.cap) missingFields.push('CAP azienda (settings)')
                if (!settings.dati_fattura.comune) missingFields.push('Comune azienda (settings)')
                if (!settings.dati_fattura.provincia) missingFields.push('Provincia azienda (settings)')
            }

            // Se ci sono campi mancanti, mostra errore
            if (missingFields.length > 0) {
                Swal.fire({
                    title: 'Campi obbligatori mancanti',
                    html: `<p>Per generare la fattura XML sono necessari i seguenti campi:</p><ul style="text-align:left;margin-top:10px;">${missingFields.map(f => `<li>${f}</li>`).join('')}</ul>`,
                    icon: 'warning',
                    confirmButtonColor: '#ffc107'
                })
                return
            }

            // Mappa le righe dell'ordine alle righe fattura
            const invoiceRows = (orderData.rows || []).map(row => {
                // Concatena discountPercentage e discountOrder per il campo discount (entrambi in %)
                const discountParts = []
                if (row.discountPercentage) discountParts.push(row.discountPercentage + '%')
                if (row.discountOrder) discountParts.push(row.discountOrder + '%')
                const discount = discountParts.join(' + ') || '0'

                return {
                    idCustomerOrderRow: { id: row.id },
                    name: row.name || '',
                    description: row.description || '',
                    quantity: row.quantity || 0,
                    listPrice: row.listPrice || 0,
                    discount: discount,
                    vat: row.idVatCondition?.percentage || row.vat || 22,
                    price: row.price || 0,
                    vatPrice: row.vatPrice || 0,
                    totalPrice: row.totalPrice || 0,
                    notes: row.notes || ''
                }
            })

            const invoiceData = {
                idCustomerOrder: { id: item.id },
                idVatCondition: orderData.idVatCondition || null,
                invoiceDate: moment().format('YYYY-MM-DD'),
                status: { value: '0_PENDING', label: '0_PENDING' },
                invoiceImponibile: orderData.totalRows || 0,
                invoiceIva: orderData.totalVat || 0,
                invoiceTotal: orderData.totalPrice || 0,
                rows: invoiceRows
            }

            const response = await DataManager.insertItem('invoice', invoiceData)
            if (response.success !== 1) {
                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile creare la fattura.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }

            Swal.fire({ title: 'Completato', text: 'Fattura creata con successo.', icon: 'success', confirmButtonColor: '#198754' })
            if (typeof refreshData === 'function') {
                refreshData()
            }
        } catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Errore durante la creazione della fattura.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    const [dataPaymentOrderModal, setDataPaymentOrderModal] = useState(false)
    async function showModalPaymentOrder(item) {
        setStatusPaymentOrderModal(true)

        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: item.id }]
        var response = await DataManager.searchItems('customer_order_payment', 1, 100, { 'field': 'id', 'order': 'desc' }, '', [], constraints)
        if (response.success === 1) {
            setDataPaymentOrderModal(response.body)
            console.warn(response.body)
        }
    }
    function closeModalPaymentOrder() {
        setStatusPaymentOrderModal(false)
        setDataPaymentOrderModal(null)
    }

    function goToPreview() {
        navigate('/page/PaymentsPreview?id=' + item.id)
    }


    const [statusModalRowsDelivery, setStatusModalRowsDelivery] = useState(false)
    const [order, setOrder] = useState(null)
    const [selectedIdsRow, setSelectedIdsRow] = useState([]);
    const selectAllDeliveryRef = useRef(null);

    const deliveryRows = useMemo(() => {
        if (!order || !Array.isArray(order.rows)) {
            return [];
        }
        return order.rows.filter((row) => {
            if (!row || row.id === undefined || row.id === null) {
                return false;
            }
            return true;
        });
    }, [order]);

    const selectableDeliveryStatuses = ['10_RECEIVED'];

    const isRowSelectable = (row) => {
        const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value);
        return selectableDeliveryStatuses.includes(String(statusValue || '').toUpperCase());
    };

    const selectableDeliveryRowIds = useMemo(() => deliveryRows.filter(isRowSelectable).map((row) => row.id), [deliveryRows]);

    useEffect(() => {
        setSelectedIdsRow((prev) => prev.filter((id) => selectableDeliveryRowIds.includes(id)));
    }, [selectableDeliveryRowIds]);

    const allDeliveryRowsSelected = selectableDeliveryRowIds.length > 0 && selectableDeliveryRowIds.every((id) => selectedIdsRow.includes(id));
    const isDeliverySelectAllIndeterminate = selectedIdsRow.length > 0 && !allDeliveryRowsSelected;

    useEffect(() => {
        if (selectAllDeliveryRef.current) {
            selectAllDeliveryRef.current.indeterminate = isDeliverySelectAllIndeterminate;
        }
    }, [isDeliverySelectAllIndeterminate]);

    const [statusModalSupplierOrders, setStatusModalSupplierOrders] = useState(false)
    const [supplierOrderDetail, setSupplierOrderDetail] = useState(null)
    const [supplierGroups, setSupplierGroups] = useState([])
    const [rowsWithoutSupplier, setRowsWithoutSupplier] = useState([])
    const [creatingSupplierOrderId, setCreatingSupplierOrderId] = useState(null)
    const [supplierOrderModalStatus, setSupplierOrderModalStatus] = useState(false)
    const [supplierOrderInitData, setSupplierOrderInitData] = useState(null)
    const [activeSupplierGroupId, setActiveSupplierGroupId] = useState(null)
    const [activeSupplierGroupRows, setActiveSupplierGroupRows] = useState([])

    const [deliveryCompilerStatus, setDeliveryCompilerStatus] = useState(false)
    const [deliveryCompilerData, setDeliveryCompilerData] = useState(null)

    const handleToggleAllDeliveryRows = (checked) => {
        if (checked) {
            setSelectedIdsRow(Array.from(selectableDeliveryRowIds));
        }
        else {
            setSelectedIdsRow([]);
        }
    };

    const handleCheck = (id, checked) => {
        if (!selectableDeliveryRowIds.includes(id)) {
            return;
        }

        if (checked) {
            setSelectedIdsRow((prev) => (prev.includes(id) ? prev : [...prev, id]));
        }
        else {
            setSelectedIdsRow((prev) => prev.filter((item) => item !== id));
        }
    };


    function closeModalRowsDelivery() {
        setStatusModalRowsDelivery(false)
        setSelectedIdsRow([])
    }
    async function openModalRowsDelivery(item) {
        setSelectedIdsRow([])
        var res = await DataManager.getItem('customer_order', item.id);
        if (res.success === 1) {
            setOrder(res.body[0])
            setStatusModalRowsDelivery(true)
        } else {
            Swal.fire({ title: 'Errore', text: res.message, icon: 'error', confirmButtonColor: '#dc3545' })
        }

    }
    async function createDelivery() {
        if (selectedIdsRow.length === 0) {
            Swal.fire({ title: 'Attenzione', text: 'Seleziona almeno una riga da consegnare.', icon: 'warning', confirmButtonColor: '#ffc107' })
            return
        }

        var rows = [];
        for (let i = 0; i < selectedIdsRow.length; i++) {
            var filtered = order?.rows?.find(item => item.id === selectedIdsRow[i]);
            console.warn(filtered)
            var row = {
                idCustomerOrderRow: { id: selectedIdsRow[i] },
                name: filtered.name,
                description: filtered.description,
                supplier: filtered.idSupplier && filtered.idSupplier.name,
                quantity: filtered.quantity,
                status: {
                    value: '0_PENDING',
                    label: '0_PENDING'
                }
            }
            rows.push(row);
        }
        console.log(order)
        var body = {
            idCustomerOrder: order,
            status: { value: '10_CREATED', label: '10_CREATED' },
            deliveryDate: order.deliveryDate,
            idUserDelivery: order.idUserDelivery ?? null,
            realDeliveryDate: order.realDeliveryDate,
            finishDeliveryDate: order.finishDeliveryDate,
            deliveryAddress: order.deliveryAddress,
            latitude: order.latitude,
            longitude: order.longitude,
            locality: order.locality,
            rows: rows
        }
        console.log(body)
        setDeliveryCompilerData(body)
        setDeliveryCompilerStatus(true)
        closeModalRowsDelivery()
    }


    function closeModalSupplierOrders() {
        setStatusModalSupplierOrders(false)
        setSupplierOrderDetail(null)
        setSupplierGroups([])
        setRowsWithoutSupplier([])
        setCreatingSupplierOrderId(null)
        closeSupplierOrderCompiler()
    }

    function closeDeliveryCompiler() {
        setDeliveryCompilerStatus(false)
        setDeliveryCompilerData(null)
    }

    async function saveDelivery(data) {
        if (!data) {
            return
        }
        try {
            const response = await DataManager.insertItem('customer_order_delivery', data)
            if (response.success !== 1) {
                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile creare la consegna.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }

            const deliveryRows = Array.isArray(data.rows) ? data.rows : []
            for (let i = 0; i < deliveryRows.length; i++) {
                const row = deliveryRows[i]
                const rowId = (row?.idCustomerOrderRow && row.idCustomerOrderRow.id) || row?.idCustomerOrderRow
                if (!rowId) {
                    continue
                }
                const update = await DataManager.updateItem('customer_order_row', { status: { value: '15_IN_DELIVERY', label: '15_IN_DELIVERY' } }, rowId)
                if (update.success !== 1) {
                    throw new Error(update.message || 'Impossibile aggiornare lo stato della riga ordine cliente.')
                }
            }

            Swal.fire({ title: 'Completato', text: 'Creazione consegna avvenuta con successo.', icon: 'success', confirmButtonColor: '#198754' })
            if (typeof refreshData === 'function') {
                refreshData()
            }
            closeDeliveryCompiler()
        }
        catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Impossibile creare la consegna.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    function closeSupplierOrderCompiler() {
        setSupplierOrderModalStatus(false)
        setSupplierOrderInitData(null)
        setActiveSupplierGroupId(null)
        setCreatingSupplierOrderId(null)
        setActiveSupplierGroupRows([])
    }

    const buildSupplierGroups = (orderDetails) => {
        if (!orderDetails || !Array.isArray(orderDetails.rows)) {
            setSupplierGroups([])
            setRowsWithoutSupplier([])
            return
        }

        const existingOrders = new Set()
        if (Array.isArray(orderDetails.supplier_orders)) {
            orderDetails.supplier_orders.forEach((supplierOrder) => {
                if (supplierOrder && supplierOrder.idSupplier && supplierOrder.idSupplier.id) {
                    existingOrders.add(supplierOrder.idSupplier.id)
                }
            })
        }

        const groupsMap = new Map()
        const missingSupplierRows = []

        orderDetails.rows.forEach((row) => {
            if (row && row.idSupplier && row.idSupplier.id) {
                const supplierId = row.idSupplier.id
                if (!groupsMap.has(supplierId)) {
                    groupsMap.set(supplierId, {
                        supplier: row.idSupplier,
                        rows: [],
                        alreadyCreated: existingOrders.has(supplierId)
                    })
                }
                groupsMap.get(supplierId).rows.push(row)
            }
            else {
                missingSupplierRows.push(row)
            }
        })

        setSupplierGroups(Array.from(groupsMap.values()))
        setRowsWithoutSupplier(missingSupplierRows)
    }

    async function openModalSupplierOrders(orderItem) {
        var res = await DataManager.getItem('customer_order', orderItem.id);
        if (res.success === 1 && res.body && res.body.length > 0) {
            const orderDetails = res.body[0]
            setSupplierOrderDetail(orderDetails)
            buildSupplierGroups(orderDetails)
            setStatusModalSupplierOrders(true)
        }
        else {
            Swal.fire({ title: 'Errore', text: res.message || 'Impossibile recuperare i dettagli dell\'ordine.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
    }

    function openSupplierOrderCompilerForGroup(group) {
        if (!supplierOrderDetail || !group || !group.supplier || group.alreadyCreated) {
            return
        }

        const rows = group.rows.map((row) => ({
            name: row.name || '',
            description: row.description || '',
            quantity: row.quantity ?? 0,
            notes: row.notes || '',
            listPriceOrder: null,
            discountPercentage: row.discountPercentage ?? 0,
            discount: row.discount ?? 0,
            idCustomerOrderRow: row.id,
            status: {
                value: '0_PENDING',
                label: '0_PENDING'
            }
        }))

        const body = {
            idSupplier: group.supplier,
            idCustomerOrder: {
                id: supplierOrderDetail.id,
                internalCode: supplierOrderDetail.internalCode || ''
            },
            customerName: supplierOrderDetail.idCustomer && supplierOrderDetail.idCustomer.name,
            internalCode: '',
            externalCode: '',
            status: {
                value: '1_TO_SEND',
                label: '1_TO_SEND'
            },
            paymentNotes: '',
            requested_delivery_date: null,
            notes: '',
            file: null,
            deliveryDate: null,
            rows: rows
        }

        setSupplierOrderInitData(body)
        setActiveSupplierGroupId(group.supplier.id)
        setActiveSupplierGroupRows(group.rows)
        setSupplierOrderModalStatus(true)
    }

    async function saveSupplierOrder(data) {
        if (!data || !activeSupplierGroupId) {
            return
        }

        setCreatingSupplierOrderId(activeSupplierGroupId)

        try {
            const response = await DataManager.insertItem('supplier_order', data)
            if (response.success !== 1) {
                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile creare l\'ordine fornitore.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }

            const supplierName = data.idSupplier && data.idSupplier.name ? data.idSupplier.name : 'fornitore'

            if (Array.isArray(activeSupplierGroupRows) && activeSupplierGroupRows.length > 0) {
                await Promise.all(activeSupplierGroupRows.map(async (row) => {
                    if (!row || !row.id) {
                        return
                    }
                    const updateRow = await DataManager.updateItem('customer_order_row', { status: { value: '5_ORDERED' } }, row.id)
                    if (updateRow.success !== 1) {
                        throw new Error(updateRow.message || 'Aggiornamento riga ordine cliente non riuscito.')
                    }
                }))
            }

            let updatedOrder = supplierOrderDetail
            const orderCheck = await DataManager.getItem('customer_order', supplierOrderDetail.id)
            if (orderCheck.success === 1 && orderCheck.body && orderCheck.body.length > 0) {
                updatedOrder = orderCheck.body[0]
                setSupplierOrderDetail(updatedOrder)
                const allOrdered = Array.isArray(updatedOrder.rows) && updatedOrder.rows.length > 0 && updatedOrder.rows.every((row) => row.status && row.status.value === '5_ORDERED')
                if (allOrdered) {
                    await DataManager.updateItem('customer_order', { status: { value: '1_ORDERED' } }, updatedOrder.id)
                }
            }

            Swal.fire({ title: 'Completato', text: `Ordine per ${supplierName} creato con successo.`, icon: 'success', confirmButtonColor: '#198754' })
            setSupplierGroups((prev) => prev.map((el) => {
                if (el.supplier && el.supplier.id === activeSupplierGroupId) {
                    return { ...el, alreadyCreated: true }
                }
                return el
            }))
            if (typeof refreshData === 'function') {
                refreshData()
            }
            closeSupplierOrderCompiler()
        }
        catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Si è verificato un errore durante la creazione dell\'ordine fornitore.', icon: 'error', confirmButtonColor: '#dc3545' })
        }
        finally {
            setCreatingSupplierOrderId(null)
        }
    }







    if (entity !== null) {
        return (
            <>

                <div className='d-flex'>
                    {item?.status?.value === '0_PENDING' ? (
                        <>
                            <Button size='sm' variant='outline-warning' onClick={() => openModalSupplierOrders(item)} className='py-0 me-1'>Ordini fornitore</Button>

                        </>
                    ) : null}
                    {item?.deliveryAvaiable === 1  ? (
                        <>
                            <Button size='sm' variant='outline-primary' onClick={() => openModalRowsDelivery(item)} className='py-0 me-1'>
                                Crea consegna <Badge>{item.righe_ricevute}/{item.rows}</Badge>
                            </Button>
                        </>
                    ) : null}
                    {/* {item?.status?.value === '1_ORDERED' || item?.status?.value === '7_READY_FOR_DELIVERY'  ? (
                        <>
                            <Button size='sm' variant='outline-primary' onClick={() => openModalRowsDelivery(item)} className='py-0 me-1'>Crea consegna</Button>
                        </>
                    ) : null} */}
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-secondary" size='sm'>
                            Azioni
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header className='py-1 small text-muted'>Pagamenti</Dropdown.Header>
                            <Dropdown.Item onClick={() => showModalPaymentOrder(item)}>
                                <FontAwesomeIcon icon='history' className='me-2 text-secondary' fixedWidth />Storico pagamenti
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => newCustomerOrderPayment(item)}>
                                <FontAwesomeIcon icon='plus-circle' className='me-2 text-success' fixedWidth />Registra pagamento
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header className='py-1 small text-muted'>Ordini</Dropdown.Header>
                            <Dropdown.Item onClick={() => openReplacementCompiler(item)}>
                                <FontAwesomeIcon icon='sync-alt' className='me-2 text-warning' fixedWidth />Crea sostituzione
                            </Dropdown.Item>
                            {settings.fatturazione && (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Header className='py-1 small text-muted'>Fatturazione</Dropdown.Header>
                                    <Dropdown.Item onClick={() => createInvoice(item)}>
                                        <FontAwesomeIcon icon='file-invoice' className='me-2 text-primary' fixedWidth />Crea fattura
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => viewInvoices(item)}>
                                        <FontAwesomeIcon icon='file-invoice-dollar' className='me-2 text-info' fixedWidth />Vedi fatture
                                    </Dropdown.Item>
                                </>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button onClick={() => previewCustomerOrder(item)} size="sm" variant="outline-secondary" className='ms-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>
                </div>


                {statusModalEntityViewerCustomerOrder !== false && (
                    <ModalEntityViewer entity={'customer_order'} item={item} status={statusModalEntityViewerCustomerOrder} closeModal={closeModalEntityViewerCustomerOrder} />
                )}
                {statusPaymentOrderModal ? (
                    <>
                        <Modal show={statusPaymentOrderModal} onHide={closeModalPaymentOrder} size='lg' scrollable>
                            <Modal.Header closeButton>
                                <Modal.Title>Storico pagamenti</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? (
                                    <Table className='table small'>
                                        <thead>
                                            <tr>
                                                <th>Data pagamento</th>
                                                <th>Importo pagato</th>
                                                <th>Stato</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataPaymentOrderModal.map((payment, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{moment(payment.paymentDate).format('DD/MM/YYYY')}</td>
                                                        <td>{payment.totalPayment} €</td>
                                                        <td>{payment.status && payment.status.value && payment.status.value === "0_PENDING" ? "In attesa" : "Generato"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <Alert>Nessun pagamento presente.</Alert>
                                )}

                                <p className='text-end'>Totale ordine: <b>{item.totalPrice} €</b></p>
                                <p className='text-end'>Totale pagato: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0) : 0} €</b></p>
                                <p className='text-end'>Rimanente: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? parseFloat(item.totalPrice - dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0)).toFixed(2) : parseFloat(item.totalPrice).toFixed(2)} €</b></p>
                            </Modal.Body>
                            <Modal.Footer>
                                {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? <Button variant="outline-secondary" onClick={() => goToPreview()}>
                                    Anteprima di stampa
                                </Button> : null}

                                <Button variant="secondary" onClick={closeModalPaymentOrder}>
                                    Chiudi
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                ) : <></>}



                <Modal show={statusModalRowsDelivery} onHide={closeModalRowsDelivery} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Seleziona righe per la consegna</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectableDeliveryRowIds.length === 0 && deliveryRows.length > 0 && (
                            <Alert variant='info' className='d-flex align-items-center'>
                                <FontAwesomeIcon icon='info-circle' className='me-2' />
                                Nessuna riga pronta per la consegna. Solo le righe con stato "Ricevuto" possono essere selezionate.
                            </Alert>
                        )}
                        {selectableDeliveryRowIds.length > 0 && (
                            <Alert variant='success' className='d-flex align-items-center py-2'>
                                <FontAwesomeIcon icon='check-circle' className='me-2' />
                                <span><strong>{selectableDeliveryRowIds.length}</strong> {selectableDeliveryRowIds.length === 1 ? 'riga pronta' : 'righe pronte'} per la consegna</span>
                            </Alert>
                        )}
                        <Table striped bordered hover responsive className='mb-0 align-middle'>
                            <thead className='table-light'>
                                <tr>
                                    <th style={{ width: 50 }} className='text-center'>
                                        <Form.Check
                                            ref={selectAllDeliveryRef}
                                            type='checkbox'
                                            disabled={selectableDeliveryRowIds.length === 0}
                                            checked={allDeliveryRowsSelected}
                                            onChange={(event) => handleToggleAllDeliveryRows(event.target.checked)}
                                        />
                                    </th>
                                    <th>Articolo</th>
                                    <th style={{ width: 150 }}>Stato</th>
                                    <th>Fornitore</th>
                                    <th style={{ width: 100 }} className='text-center'>Quantità</th>
                                    <th>Note</th>
                                </tr>
                            </thead>
                            <tbody>
                                {deliveryRows.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className='text-center text-muted py-4'>
                                            <FontAwesomeIcon icon='box-open' className='me-2' />
                                            Nessuna riga disponibile.
                                        </td>
                                    </tr>
                                ) : (
                                    deliveryRows.map((element) => {
                                        const rawStatus = typeof element?.status === 'string' ? element.status : element?.status?.value
                                        const statusLabel = rawStatus ? LanguageProvider.getLabel('customer_order_row', `status.options.${rawStatus}`) : '-'
                                        const selectable = isRowSelectable(element)
                                        const getStatusVariant = (status) => {
                                            if (!status) return 'secondary'
                                            const s = String(status).toUpperCase()
                                            if (s === '10_RECEIVED') return 'success'
                                            if (s === '15_IN_DELIVERY') return 'info'
                                            if (s === '20_DELIVERED') return 'primary'
                                            if (s.includes('PENDING') || s.includes('0_')) return 'warning'
                                            if (s.includes('ORDERED') || s.includes('5_')) return 'secondary'
                                            return 'secondary'
                                        }
                                        return (
                                            <tr key={element.id} style={{ opacity: selectable ? 1 : 0.5 }}>
                                                <td className='text-center'>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`row-${element.id}`}
                                                        disabled={!selectable}
                                                        checked={selectedIdsRow.includes(element.id)}
                                                        onChange={(e) => handleCheck(element.id, e.target.checked)}
                                                    />
                                                </td>
                                                <td className='fw-medium'>{element.name ?? "-"}</td>
                                                <td>
                                                    <Badge bg={getStatusVariant(rawStatus)} className='px-2 py-1'>
                                                        {statusLabel || '-'}
                                                    </Badge>
                                                </td>
                                                <td>{element.idSupplier?.name ?? "-"}</td>
                                                <td className='text-center fw-bold'>{element.quantity ?? 0}</td>
                                                <td>{element.notes ?? "-"}</td>
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer className='bg-light'>
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <span className='text-muted small'>
                                {selectedIdsRow.length > 0 && (
                                    <><FontAwesomeIcon icon='check-square' className='me-1' /> {selectedIdsRow.length} {selectedIdsRow.length === 1 ? 'riga selezionata' : 'righe selezionate'}</>
                                )}
                            </span>
                            <div>
                                <Button variant='outline-secondary' onClick={() => closeModalRowsDelivery()} className='me-2'>
                                    Annulla
                                </Button>
                                <Button variant='primary' onClick={() => createDelivery()} disabled={selectedIdsRow.length === 0}>
                                    Crea consegna
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>


                <Modal show={statusModalSupplierOrders} onHide={closeModalSupplierOrders} size='lg' scrollable>
                    <Modal.Header closeButton>
                        <Modal.Title>Ordini fornitore</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {rowsWithoutSupplier.length > 0 ? (
                            <Alert variant='warning'>
                                <p className='mb-2'>Alcune righe non hanno un fornitore associato e non possono essere incluse in un ordine:</p>
                                <ul className='mb-0'>
                                    {rowsWithoutSupplier.map((row, index) => (
                                        <li key={row?.id || index}>
                                            {row?.code ? `${row.code} - ` : ''}{row?.name || 'Articolo senza nome'}
                                        </li>
                                    ))}
                                </ul>
                            </Alert>
                        ) : null}

                        {supplierGroups.length > 0 ? (
                            supplierGroups.map((group, index) => (
                                <div key={group?.supplier?.id || index} className='mb-4'>
                                    <div className='d-flex justify-content-between align-items-center mb-2'>
                                        <h6 className='mb-0'>Fornitore: {group?.supplier?.name || '---'}</h6>
                                    </div>
                                    <Table bordered size='sm' responsive>
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Quantità</th>
                                                <th>Prezzo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {group.rows.map((row) => {
                                                const rawPrice = row.price ?? row.listPriceOrder ?? 0
                                                const displayPrice = !Number.isNaN(parseFloat(rawPrice)) ? parseFloat(rawPrice).toFixed(2) : rawPrice
                                                return (
                                                    <tr key={row.id}>
                                                        <td>{row.name || '-'}</td>
                                                        <td>{row.quantity ?? 0}</td>
                                                        <td>{displayPrice}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                    <div className='text-end'>
                                        <Button
                                            variant={group.alreadyCreated ? 'success' : 'primary'}
                                            size='sm'
                                            className='mt-2'
                                            disabled={group.alreadyCreated || creatingSupplierOrderId === (group?.supplier?.id || null)}
                                            onClick={() => openSupplierOrderCompilerForGroup(group)}
                                        >
                                            {group.alreadyCreated ? "Ordine già creato" : `Crea ordine fornitore ${group?.supplier?.name || ''}`}
                                        </Button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <Alert variant='secondary'>Nessuna riga disponibile per creare ordini fornitore.</Alert>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={closeModalSupplierOrders}>Chiudi</Button>
                    </Modal.Footer>
                </Modal>


                <ModalEntityCompiler
                    entity={'supplier_order'}
                    initData={supplierOrderInitData}
                    close={closeSupplierOrderCompiler}
                    status={supplierOrderModalStatus}
                    confirmCallback={saveSupplierOrder}
                />

                <ModalEntityCompiler
                    entity={'customer_order_delivery'}
                    initData={deliveryCompilerData}
                    close={closeDeliveryCompiler}
                    status={deliveryCompilerStatus}
                    confirmCallback={saveDelivery}
                />

                <ModalEntityCompiler
                    entity={'customer_order_payment'}
                    initData={paymentCompilerData}
                    close={closePaymentCompiler}
                    status={paymentCompilerStatus}
                    confirmCallback={async (data) => {
                        if (!data) {
                            return
                        }
                        try {
                            const response = await DataManager.insertItem('customer_order_payment', data)
                            if (response.success !== 1) {
                                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile registrare il pagamento.', icon: 'error', confirmButtonColor: '#dc3545' })
                                return
                            }
                            Swal.fire({ title: 'Completato', text: 'Pagamento registrato con successo.', icon: 'success', confirmButtonColor: '#198754' })
                            closePaymentCompiler()
                            if (typeof refreshData === 'function') {
                                refreshData()
                            }
                        } catch (error) {
                            Swal.fire({ title: 'Errore', text: error.message || 'Errore durante la registrazione del pagamento.', icon: 'error', confirmButtonColor: '#dc3545' })
                        }
                    }}
                />

                <ModalEntityCompiler
                    entity={'customer_order'}
                    initData={replacementCompilerData}
                    close={closeReplacementCompiler}
                    status={replacementCompilerStatus}
                    confirmCallback={async (data) => {
                        if (!data) {
                            return
                        }
                        try {
                            const response = await DataManager.insertItem('customer_order', data)
                            if (response.success !== 1) {
                                Swal.fire({ title: 'Errore', text: response.message || 'Impossibile creare l\'ordine di sostituzione.', icon: 'error', confirmButtonColor: '#dc3545' })
                                return
                            }
                            Swal.fire({ title: 'Completato', text: 'Ordine di sostituzione creato con successo.', icon: 'success', confirmButtonColor: '#198754' })
                            closeReplacementCompiler()
                            if (typeof refreshData === 'function') {
                                refreshData()
                            }
                        } catch (error) {
                            Swal.fire({ title: 'Errore', text: error.message || 'Errore durante la creazione dell\'ordine di sostituzione.', icon: 'error', confirmButtonColor: '#dc3545' })
                        }
                    }}
                />

            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
